import LegalLayout from './LegalLayout';
import Seo from '../components/Seo';

export default function TermsOfService() {
  return (
    <LegalLayout title="Kullanım Koşulları">
      <Seo
        title="Kullanım Koşulları | Mahallebi"
        description="Mahallebi platformu kullanım koşulları: hak ve yükümlülükler, ilan kuralları, güvenlik ve sorumluluklar."
        path="/terms"
      />
      <p className="text-sm text-gray-500 mb-6">Son güncelleme: 29 Mart 2026</p>

      <Section title="1. Giriş ve Kabul">
        <p>
          Bu Kullanım Koşulları ("Koşullar"), UBS Bilişim Teknolojileri ("Şirket") tarafından geliştirilen
          ve işletilen Mahallebi mobil uygulaması ve web platformu ("Platform") ile ilgili hak ve
          yükümlülüklerinizi düzenlemektedir. Platformu kullanarak bu Koşulları kabul etmiş sayılırsınız.
        </p>
      </Section>

      <Section title="2. Hizmet Tanımı">
        <p className="mb-3">
          Mahallebi, mahalle bazlı sosyal ticaret platformudur. Platform aşağıdaki hizmetleri sunar:
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Ürün ve hizmet ilanları oluşturma ve paylaşma</li>
          <li>Talep ve duyuru yayınlama</li>
          <li>Acil yardım talep etme ve yanıtlama</li>
          <li>Kullanıcılar arası mesajlaşma</li>
          <li>Konum bazlı komşu keşfi ve güven puanlama sistemi</li>
        </ul>
      </Section>

      <Section title="3. Üyelik ve Hesap Güvenliği">
        <ul className="list-disc pl-6 space-y-2">
          <li>Platformu kullanmak için 18 yaşını doldurmuş olmanız gerekmektedir.</li>
          <li>Hesap oluştururken doğru ve güncel bilgi sağlamakla yükümlüsünüz.</li>
          <li>Hesap bilgilerinizin güvenliğinden siz sorumlusunuz.</li>
          <li>Hesabınızda yetkisiz bir kullanım fark ederseniz derhal bizi bilgilendirmelisiniz.</li>
          <li>Bir kişi yalnızca bir hesap oluşturabilir. Çoklu hesap kullanımı yasaktır.</li>
        </ul>
      </Section>

      <Section title="4. Kullanıcı Yükümlülükleri">
        <p className="mb-3">Platform kullanıcıları aşağıdaki kurallara uymakla yükümlüdür:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Yasalara ve ahlak kurallarına aykırı içerik paylaşmamak</li>
          <li>Yanıltıcı, sahte veya aldatıcı ilanlar vermemek</li>
          <li>Diğer kullanıcılara hakaret, tehdit veya tacizde bulunmamak</li>
          <li>Platformun teknik altyapısına zarar verecek eylemlerden kaçınmak</li>
          <li>Spam, reklam veya istenmeyen mesaj göndermemek</li>
          <li>Başkalarının kişisel bilgilerini izinsiz paylaşmamak</li>
          <li>Yasadışı ürün veya hizmet ilanı vermemek</li>
        </ul>
      </Section>

      <Section title="5. İçerik Politikası">
        <p className="mb-3">Platformda paylaşılan içeriklerle ilgili kurallar:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Kullanıcılar, paylaştıkları tüm içeriklerden yasal olarak sorumludur.</li>
          <li>Şirket, uygunsuz, yanıltıcı veya zararlı içerikleri önceden bildirim yapmaksızın kaldırma hakkını saklı tutar.</li>
          <li>Telif hakkı, marka hakkı veya fikri mülkiyet ihlalleri kesinlikle yasaktır.</li>
          <li>İçerikler yapay zeka destekli moderasyon sistemi ve kullanıcı şikayetleri ile denetlenir.</li>
          <li>Tekrarlayan ihlallerde hesap geçici veya kalıcı olarak askıya alınabilir.</li>
        </ul>
      </Section>

      <Section title="6. İlan ve İşlem Kuralları">
        <ul className="list-disc pl-6 space-y-2">
          <li>İlanlar, gerçek ürün veya hizmetlere ait olmalıdır.</li>
          <li>Fiyatlar doğru ve güncel olmalıdır.</li>
          <li>Mahallebi, kullanıcılar arasındaki ticari işlemlerde aracı konumundadır ve doğrudan taraf değildir.</li>
          <li>Ödeme, teslimat ve iade süreçleri kullanıcılar arasında gerçekleşir.</li>
          <li>Platform üzerinden yapılan işlemlerden doğan anlaşmazlıklarda Şirket arabuluculuk yapabilir ancak sorumluluk kabul etmez.</li>
        </ul>
      </Section>

      <Section title="7. Acil Yardım Modülü">
        <ul className="list-disc pl-6 space-y-2">
          <li>Acil yardım modülü, komşular arası dayanışma amacıyla tasarlanmıştır.</li>
          <li>Bu modül, resmi acil yardım hizmetlerinin (112, 155 vb.) yerini almaz.</li>
          <li>Kötüye kullanım durumunda hesap askıya alınır.</li>
          <li>Acil durumlarda öncelikle resmi makamlarla iletişime geçmeniz önerilir.</li>
        </ul>
      </Section>

      <Section title="8. Fikri Mülkiyet Hakları">
        <p>
          Mahallebi platformunun tasarımı, logosu, yazılımı ve tüm içeriği UBS Bilişim Teknolojileri'ne
          aittir ve telif hakkı ile korunmaktadır. İzinsiz kopyalama, dağıtma veya değiştirme yasaktır.
        </p>
      </Section>

      <Section title="9. Sorumluluk Sınırlaması">
        <ul className="list-disc pl-6 space-y-2">
          <li>Platform "olduğu gibi" sunulmaktadır ve kesintisiz çalışma garantisi verilmez.</li>
          <li>Kullanıcılar arası işlemlerden doğan zararlardan Şirket sorumlu tutulamaz.</li>
          <li>Üçüncü taraf bağlantılarından kaynaklanan sorunlardan sorumluluk kabul edilmez.</li>
          <li>Doğal afet, teknik arıza gibi mücbir sebep durumlarında hizmet kesintisi yaşanabilir.</li>
        </ul>
      </Section>

      <Section title="10. Hesap Sonlandırma">
        <ul className="list-disc pl-6 space-y-2">
          <li>Kullanıcılar istedikleri zaman hesaplarını silebilir.</li>
          <li>Şirket, bu Koşulları ihlal eden kullanıcıların hesaplarını askıya alma veya kalıcı olarak kapatma hakkını saklı tutar.</li>
          <li>Hesap silme işlemi KVKK kapsamında kişisel verilerin anonimleştirilmesini içerir.</li>
        </ul>
      </Section>

      <Section title="11. Değişiklikler">
        <p>
          Bu Koşullar, gerekli görüldüğünde güncellenebilir. Önemli değişiklikler uygulama içi bildirim
          veya e-posta ile duyurulur. Güncelleme sonrası Platformu kullanmaya devam etmeniz, değişiklikleri
          kabul ettiğiniz anlamına gelir.
        </p>
      </Section>

      <Section title="12. Uygulanacak Hukuk ve Yetkili Mahkeme">
        <p>
          Bu Koşullar Türkiye Cumhuriyeti kanunlarına tabidir. Uyuşmazlıklarda İstanbul Mahkemeleri
          ve İcra Daireleri yetkilidir.
        </p>
      </Section>

      <Section title="13. İletişim">
        <p className="mb-2">Bu Koşullar hakkında sorularınız için:</p>
        <ul className="list-none space-y-1">
          <li><strong>Şirket:</strong> UBS Bilişim Teknolojileri</li>
          <li><strong>E-posta:</strong>{' '}
            <a href="mailto:info@ubsbilisim.com" className="text-[#e77e23] hover:underline">info@ubsbilisim.com</a>
          </li>
          <li><strong>Web:</strong>{' '}
            <a href="https://www.ubsbilisim.com" target="_blank" rel="noopener noreferrer" className="text-[#e77e23] hover:underline">www.ubsbilisim.com</a>
          </li>
        </ul>
      </Section>
    </LegalLayout>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section className="mb-8">
      <h2 className="text-xl font-semibold text-[#111827] mb-3">{title}</h2>
      {children}
    </section>
  );
}
